import React from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../ui/form";
import { useFormContext } from "react-hook-form";
import { Checkbox } from "../ui/checkbox";
import { Label } from "../ui/label";

type OptionType = {
  label: string;
  value: string;
};
type Props = {
  label: string;
  multiple?: boolean;
  name: string;
  required?: boolean;
  options: string[] | OptionType[];
  defaultvalue?: any | any[];
  disabled ? :boolean
};

const optionValuesMatch = (a: unknown, b: unknown) =>
  String(a ?? "").trim() === String(b ?? "").trim();

const RhfChecked = ({
  label,
  name,
  multiple,
  defaultvalue,
  required,
  options,
  disabled = false,
  ...props
}: Props) => {
  const { control } = useFormContext();
  const newOptions =
    options && Array.isArray(options)
      ? typeof options?.[0] == "string"
        ? options.map((opt) => ({ label: opt, value: opt }))
        : options
      : [];
  return (
    <FormField
      control={control}
      name={name}
      defaultValue={defaultvalue}
      render={({ field }) => (
        <FormItem  className="w-full">
          {label && (
            <FormLabel>
              {label}
              {required ? "*" : ""}
            </FormLabel>
          )}
          <FormControl >
            <div className="space-y-2">
              {newOptions.map((opt: any) => (
                <div key={opt?.value} className="flex items-center gap-2">
                  <Checkbox
                    disabled={disabled}
                    
                    checked={
                      multiple
                        ? Array.isArray(field.value) &&
                          field.value.some((v) =>
                            optionValuesMatch(v, opt?.value),
                          )
                        : optionValuesMatch(field.value, opt?.value)
                    }
                    id={`${name}-${opt?.value}`}
                    onCheckedChange={(checked) => {
                      if (multiple) {
                        field.onChange(
                          checked
                            ? Array.isArray(field.value)
                              ? [...field.value, opt?.value]
                              : [opt?.value]
                            : Array.isArray(field.value)
                              ? field.value.filter(
                                  (val) => !optionValuesMatch(val, opt.value),
                                )
                              : [],
                        );
                      } else {
                        field.onChange( checked? opt?.value 
                          : "");
                      }
                    }}
                  />
                  <Label className="text-xs text-gray-700" htmlFor={`${name}-${opt?.value}`}>{opt.label}</Label>
                </div>
              ))}
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default RhfChecked;
